export const ROOM_LINK_TITLE_CONFIG = typeOfPRoperty => ({
  name: `${typeOfPRoperty}.for-rent`,
  params: `for-rent:${typeOfPRoperty}`
});

export const ROOM_LINK_CONFIG = typeOfPRoperty => [
  {
    name: `${typeOfPRoperty}-1`,
    params: `for-rent:${typeOfPRoperty}/bedrooms:1`
  },
  {
    name: `${typeOfPRoperty}-2`,
    params: `for-rent:${typeOfPRoperty}/bedrooms:2`
  },
  {
    name: `${typeOfPRoperty}-3`,
    params: `for-rent:${typeOfPRoperty}/bedrooms:3`
  }
];

export default {
  ROOM_LINK_CONFIG,
  ROOM_LINK_TITLE_CONFIG
};
